import React, { Component } from "react";
import "./styles.scss";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import ApproveForm from '../../components/ApproveForm';
import moment from 'moment';
import 'moment/locale/vi';
import {
    getApproveList
} from "../../core/actions/approveAction";
import ProjectTable from "../../components/ProjectTable";
import functionCommon from '../../core/common/function';
import { getApproveSecretKey } from "../../core/actions/commonAction";

class Approve extends Component {
    constructor(props) {
        super(props);
        const regex = /[?&]([^=#]+)=([^&#]*)/g;
        const url = window.location;
        let  params = {};
        let match;
        while(match = regex.exec(url)) {
            params[match[1]] = match[2];
        }
        const month = (params['month'] && params['month'].length === 2) ? params['month'] : moment().format('MM');
        const year = (params['year'] && params['year'].length === 4) ? params['year'] : moment().format('YYYY');
        const paramDate = year + '-' + month;

        this.state = {
            tableStructure: [
                {
                    label: "labels.id",
                    type: "id",
                    isClass: "first-col"
                },
                {
                    label: "labels.employeeCode",
                    type: "employeeCode",
                },
                {
                    label: "labels.employeeName",
                    type: "employeeName",
                },
                {
                    label: "labels.status",
                    type: "status",
                    isChangeText: true,
                    arrayTextChange: {
                        '0': 'labels.waiting',
                        '1': 'labels.submitted',
                        '2': 'labels.approved',
                        '3': 'labels.rejected',
                        '4': 'labels.reSubmitted'
                    },
                },
                {
                    label: "labels.action",
                    type: "action",
                    action: "labels.detail",
                    isClassButton: "ui primary button tiny"
                }
            ],
            paramList: {
                approveId: functionCommon.getInfoUser('employeeId'),
                date: paramDate,
                sortBy: 'employeeCode-ASC',
                supervisorId: functionCommon.getInfoUser('employeeId')
            },
            data: [],
            month: moment().month(),
            year: moment().year(),
            errorCode: ""
        };
    }

    componentWillMount() {
        this.props.getApproveList(this.state.paramList);
        this.setState({
            month: moment(this.state.paramList.date).format('MM'),
            year: moment(this.state.paramList.date).format('YYYY')
        });
        this.props.getApproveSecretKey(
            {
                'urlGetkey': "employee/requestSecretKey"
            },
            this.state.paramList
        );
    }

    componentWillReceiveProps(nextProps) {
        let data = nextProps.approveReducer.dataApprove.employeeWorkLog;
        this.setState({
            data: data
        });

        // No data
        if (!data || (data && !data[0])) {
            this.setState({
                errorCode: "018"
            });
            setTimeout(
                function () {
                    this.setState({ errorCode: "" });
                    nextProps.approveReducer.errorCode = "";
                }.bind(this),
                2000
            );

        } else {
            this.setState({
                exportDisabled: false,
                errorCode: ""
            });
        }
    }

    onRowClick = (value) => {}

    async searchApproveList(date) {
        const searchParam = {
            date: date,                
            sortBy: this.state.paramList.sortBy,
            approveId: this.state.paramList.approveId,
            supervisorId: this.state.paramList.supervisorId
        };
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + 
        '?month=' + moment(date).format('MM')  + '&year=' + moment(date).format('YYYY');
        window.history.pushState({path:newurl},'', newurl);
        
        await this.setState({
            paramList: searchParam,
            month: moment(date).format('MM'),
            year: moment(date).format('YYYY')
        });

        return this.props.getApproveList(searchParam);
    }

    handleKeyDown = (event) => {
        if (event.keyCode === 8 || event.keyCode === 46) {
            event.preventDefault();
        }
    }

    render() {
        const { t } = this.props;
        const { errorCode } = this.state;
        return (
            <div className="approve-list-wrap">
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location.reload() }, 500)}>
                        {t("navigation.approve")}
                    </span>
                </h2>
                <ApproveForm
                    paramDate={this.state.paramList.date}
                    searchApproveList={(date) => this.searchApproveList(date)}
                />
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {t("message." + errorCode)}
                    </div>
                ) : ''}
                <ProjectTable
                    tableStructure={this.state.tableStructure}
                    dataList={this.state.data}
                    onRowClick={val => this.onRowClick(val)}
                    month={this.state.month}
                    year={this.state.year}
                    secretKey={this.props.commonReducer.secretKey}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    getApproveList: opt => dispatch(getApproveList(opt)),
    getApproveSecretKey: (url, param) => dispatch(getApproveSecretKey(url, param))
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(Approve);
